import React, { useEffect } from 'react';
import { ErrorPage } from '@src/shared/ui';
import { useProposalState, useGTM } from '@src/shared/hooks';
import { GTMEvents } from '@src/config/gtm';

export const EmailInvalidPage: React.FC = () => {
  const { proposal } = useProposalState();
  const { trackEvent } = useGTM();

  useEffect(() => {
    trackEvent(GTMEvents.EMAIL_VALIDATION_ERROR, {
      proposal_id: proposal.proposalId,
    });
  }, []);

  return (
    <ErrorPage
      title='Não foi possível validar o seu e-mail, o código informado está incorreto'
      description="Por favor, refaça seu pedido no site da GOL Linhas Aéreas, cadastre um e-mail válido e selecione o 'Boleto Parcelado PaGol' como forma de pagamento. Estamos aguardando!"
      backToGolButtonPrimary
    />
  );
};
